import MessageTemplatesComponent from 'components/Message/MessageTemplatesComponent/MessageTemplatesComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import './MessageTemplates.css';

function MessageTemplates() {
  return (
    <>
      <div className="message-templates layout-full-height">
        <Header />

        <ContainerComponent className="layout-main-content">
          <>
            <MessageTemplatesComponent />
          </>
        </ContainerComponent>

        <Footer />
      </div>
    </>
  );
}

export default MessageTemplates;
